import React from "react";
import {
    Text,
    Box,
    useDisclosure,
    type PlacementWithLogical,
} from "@chakra-ui/react";
import { TbCopy } from "react-icons/tb";
import PartNumberChangeModal from "../modals/PartNumberChangeModal";
import CopyButton from "./CopyButton";

interface PartNumberInterface {
    partNumber: string;
    correctedPartNumber?: string;
    vin: string;
    /** Copy tooltip placement; use `"bottom"` for the first table row so the bubble clears sticky headers. */
    copyPlacement?: PlacementWithLogical;
}

const PartNumber = ({ partNumber, correctedPartNumber, vin, copyPlacement = 'top' }: PartNumberInterface) => {
    const { isOpen, onOpen, onClose } = useDisclosure();

    return (
        <>
            {(correctedPartNumber || partNumber) ? (
                <CopyButton
                    text={correctedPartNumber ?? partNumber}
                    label="Copy part number"
                    placement={copyPlacement}
                    iconAs={TbCopy as unknown as React.ComponentProps<typeof CopyButton>['iconAs']}
                    tooltipAnchor={
                        <Box
                            border={!!correctedPartNumber ? '1px solid red' : 'none'}
                            borderRadius="md"
                            px={!!correctedPartNumber ? 2 : 0}
                            py={!!correctedPartNumber ? 1 : 0}
                            cursor={!!correctedPartNumber ? 'pointer' : 'default'}
                            onClick={!!correctedPartNumber ? (e: React.MouseEvent) => {
                                e.stopPropagation();
                                onOpen();
                            } : undefined}
                            _hover={!!correctedPartNumber ? { bg: 'red.50' } : undefined}
                        >
                            <Text color={!!correctedPartNumber ? 'red.600' : 'gray.900'} fontSize="sm">
                                {correctedPartNumber || partNumber || '—'}
                            </Text>
                        </Box>
                    }
                />
            ) : (
                <Text color="gray.900" fontSize="sm">—</Text>
            )}

            {correctedPartNumber && (
                <PartNumberChangeModal
                    isOpen={isOpen}
                    onClose={onClose}
                    partNumber={partNumber}
                    correctedPartNumber={correctedPartNumber}
                    vin={vin}
                />
            )}
        </>
    );
};

export default PartNumber;